import * as React from 'react';
import { toast } from 'react-toastify';
import DriverJobsSiteDepartureQuestionsData from './DriverJobsSiteDepartureQuestions';

interface DriverJobsSiteDeparturePartQuestionsProps {
    jobType: number;        //1 = Install, 2 = Pickup, 3 Both Install and Pickup Items
    isKwikstage: boolean;   //One or more of the items is Kwikstage
    completionCheck: CompletionCheck;
    team: GenericList[];
    saveDisabled: boolean;
    back(): void;
    update(completionCheck: CompletionCheck): void;
    save(): void;
}

interface DriverJobsSiteDeparturePartQuestions {
    loading: boolean;
    errors: any;
}

interface CompletionCheck {
    swmsSiteContact: number;
    scaffoldSquare: number;
    scaffoldGaps: number;
    accessPointsInstalled: number;
    scaffoldSupported: number;
    safetySigns: number;
    handrailsChecked: number;
    gapsChecked: number;
    fittingsSecure: number;
    siteChecked: number;
    rubbishInBin: number;
    siteSecured: number;
    scaffoldSafeCondition: number;
    scaffoldDamage: number;
    missingEquipment: number;
    scaffoldCertificateSigned: number;
    scaffoldTicketPhoto: number;
    scaffoldPhotosComplete: number;
    scaffoldTicketSignedById: number;
    notes: string;
}

interface GenericList {
    id: number;
    name: string;
}

export default class DriverJobsSiteDeparturePartQuestionsData extends React.Component<DriverJobsSiteDeparturePartQuestionsProps, DriverJobsSiteDeparturePartQuestions> {
    constructor(props: DriverJobsSiteDeparturePartQuestionsProps) {
        super(props);

        this.state = {
            loading: false,
            errors: {}
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    back = (e: any) => {
        e.preventDefault();

        this.props.back();
    }

    updatePartCompleteCheck = (completeCheck: CompletionCheck) => {
        this.props.update(completeCheck);
    }

    updateErrors = (errors: any) => {
        this.setState({ errors: errors });
    }

    validate = () => {
        let errors: any = {};
        let formIsValid = true;
        let fields = this.props.completionCheck;

        //Install AND Dismantle/Pickup Questions
        if (fields.swmsSiteContact < 0) {
            formIsValid = false;
            errors["swmsSiteContact"] = "Copy of SWMS is required";
        }
        if (fields.safetySigns < 0) {
            formIsValid = false;
            errors["safetySigns"] = "Scaffold Safety Signs is required";
        }
        if (fields.siteChecked < 0) {
            formIsValid = false;
            errors["siteChecked"] = "Site Checked is required";
        }
        if (fields.rubbishInBin < 0) {
            formIsValid = false;
            errors["rubbishInBin"] = "Rubbish in Bin is required";
        }
        if (fields.siteSecured < 0) {
            formIsValid = false;
            errors["siteSecured"] = "Site Secured is required";
        }

        //Install Questions
        if (this.props.jobType === 1 || this.props.jobType === 3) {
            if (fields.scaffoldSquare < 0) {
                formIsValid = false;
                errors["scaffoldSquare"] = "Scaffold neat/square/plumb is required";
            }
            if (fields.scaffoldGaps < 0) {
                formIsValid = false;
                errors["scaffoldGaps"] = "Scaffold Gaps is required";
            }
            if (fields.accessPointsInstalled < 0) {
                formIsValid = false;
                errors["accessPointsInstalled"] = "Access Points Installed is required";
            }
            if (this.props.isKwikstage && fields.scaffoldSupported < 0) {
                formIsValid = false;
                errors["scaffoldSupported"] = "Scaffold Supported is required";
            }
            if (fields.handrailsChecked < 0) {
                formIsValid = false;
                errors["handrailsChecked"] = "Handrails Checked is required";
            }
            if (fields.gapsChecked < 0) {
                formIsValid = false;
                errors["gapsChecked"] = "Gaps Checked is required";
            }
            if (fields.fittingsSecure < 0) {
                formIsValid = false;
                errors["fittingsSecure"] = "Fittings Secure is required";
            }
            if (fields.scaffoldCertificateSigned < 0) {
                formIsValid = false;
                errors["scaffoldCertificateSigned"] = "Scaffold Certificate Signed is required";
            } else if (fields.scaffoldCertificateSigned === 1 && fields.scaffoldTicketSignedById < 0) {
                formIsValid = false;
                errors["scaffoldTicketSignedById"] = "Scaffold Ticked Signed By is required";
            }

            if (fields.scaffoldTicketPhoto < 0) {
                formIsValid = false;
                errors["scaffoldTicketPhoto"] = "Scaffold Ticket Photo is required";
            }
            if (fields.scaffoldPhotosComplete < 0) {
                formIsValid = false;
                errors["scaffoldPhotosComplete"] = "Scaffold Photos Complete is required";
            }
        }

        //Dismantle/Pickup Questions
        if (this.props.jobType === 2 || this.props.jobType === 3) {
            if (fields.scaffoldSafeCondition < 0) {
                formIsValid = false;
                errors["scaffoldSafeCondition"] = "Scaffold Safe Condition is required";
            }
            if (fields.scaffoldDamage < 0) {
                formIsValid = false;
                errors["scaffoldDamage"] = "Scaffold Damage is required";
            }
            if (fields.missingEquipment < 0) {
                formIsValid = false;
                errors["missingEquipment"] = "Missing Equipment is required";
            }
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    save = (e: any) => {
        e.preventDefault();

        if (this.validate()) {
            this.props.save();
        } else {
            toast.error("Fix validation errors on screen before going Next");
        }
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        var questions = <DriverJobsSiteDepartureQuestionsData jobType={this.props.jobType} isKwikstage={this.props.isKwikstage} completionCheck={this.props.completionCheck} team={this.props.team} errors={this.state.errors} update={this.updatePartCompleteCheck} updateErrors={this.updateErrors} />

        return (
            <div>
                <div className="mobileFont marginTop10 marginBottom10">
                    <div className="makeitflexspacebetween marginBottom10">
                        <h2 className="mobile-margin">Job Partically Complete</h2>
                        <i className="mobile-icon-grey fas fa-arrow-alt-circle-left mobileMenuSize" onClick={(e) => this.back(e)}></i>
                    </div>

                    {questions}

                    <div className="defaultbutton__container--right marginTop10">
                        <i className={"mobile-icon-green fas fa-circle-check mobileMenuSize" + (this.props.saveDisabled ? " mobile-image-button--disabled" : "")} onClick={(e) => this.save(e)}></i>
                    </div>
                </div>
            </div>
        );

    }
}
